module.exports = __webpack_public_path__ + "12df3041ff850dcb530452f662fc129f.woff2";